const AUTH_TRANSIENT_PARAMS = [
  'h',
  'ls',
  'loc',
  'api_product',
  'sso_env',
  'login_type',
  'points',
  'result',
] as const;

export function getAuthCallbackUrl(href = window.location.href): string {
  const hashIndex = href.indexOf('#');
  const base = hashIndex >= 0 ? href.slice(0, hashIndex) : href;
  const hash = hashIndex >= 0 ? href.slice(hashIndex) : '';

  const url = new URL(base);
  AUTH_TRANSIENT_PARAMS.forEach((key) => url.searchParams.delete(key));

  return `${url.toString()}${hash}`;
}

export function replaceBrowserUrlWithAuthCallback(): void {
  const cleanUrl = getAuthCallbackUrl();
  if (cleanUrl !== window.location.href) {
    window.history.replaceState({}, '', cleanUrl);
  }
}
